// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import CloudBackupRestriction from './CloudBackupRestriction';

module.exports = ({ container, locale, ...props }) => {
    render((
        <LocaleProvider messages={locale}>
            <CloudBackupRestriction {...props} />
        </LocaleProvider>
    ), container);
};



// WEBPACK FOOTER //
// ./app/cloud-backup-restriction/index.js